import moment from 'moment';

// returns JS Date to be used by react-widgets DateTimePicker 
const defaultDatePeriodFrom = () => {
	const date = new Date();
	date.setHours(0);
	date.setMinutes(0);
	date.setSeconds(0);
	date.setMilliseconds(0);
	return date;
};

// returns JS Date to be used by react-widgets DateTimePicker 
const defaultDatePeriodTo = () => {
	const date = new Date();
	date.setHours(23);
	date.setMinutes(59);
	date.setSeconds(59);
	date.setMilliseconds(999);
	return date;
};

const parseTime = (text, format) => {
	if (!format) {
		format = 'HH:mm';
	}
	return parseDateTime(text, format);
};

const parseDateTime = (text, format) => {
	if (text) {
		if (format) {
			return moment(text, format).toDate();
		} else {
			return moment(text).toDate();
		}
	}
	return moment().toDate();
};

const isUpcomingDate = (date, utcOffset) => {
	return moment(date).utcOffset(utcOffset, true) > moment();
};

const filter = (object, predicate) => {
	if (!object) {
		return {};
	}

	const result = {};
	for (const key in object) {
		if (predicate(object[key])) {
			result[key] = object[key];
		}
	}
	return result;
};

const toObject = (array, key) => {
	if (!array) {
		return {};
	}

	const result = {};
	for (let i = 0; i < array.length; ++i) {
		const value = array[i];
		if (typeof value === 'object') {
			result[value[key]] = value;
		} else {
			result[i] = value;
		}
	}
	return result;
};

const first = (object) => Object.values(object).find(() => true);

const getCurrentMonth = () => {
	return moment().month() + 1;
};

const getCurrentYear = () => {
	return moment().year();
};

const getCurrentSchoolYear = () => {
	const d = moment();
	const currentYear = d.year();

	if (d.month() >= 8) // from September show school year started in current year, TODO: school year doesn't necessarily start in September!
		return currentYear;
	else
		return currentYear - 1;
};

const groupBy = (array, prop) => {
	return array.reduce((groups, item) => {
		if (item) {
			const val = item[prop];
			groups[val] = groups[val] || [];
			groups[val].push(item);
		}
		return groups;
	}, {});
};

const getAgeFromBirthday = (dateOfBirth) => {
	if (dateOfBirth) {
		const totalMonths = moment().diff(dateOfBirth, 'months');
		const years = parseInt(totalMonths / 12);
		const months = totalMonths % 12;
		return {
			years: years || 0,
			months: months || 0
		};
	}
	return null;
};

const copyToClipboard = (text) => {
	navigator.clipboard.writeText(text);
};

export default {
	defaultDatePeriodFrom,
	defaultDatePeriodTo,
	parseTime,
	parseDateTime,
	filter,
	getCurrentMonth,
	getCurrentYear,
	getCurrentSchoolYear,
	toObject,
	first,
	isUpcomingDate,
	groupBy,
	getAgeFromBirthday,
	copyToClipboard
};